
import { Component, Vue, Prop } from "vue-property-decorator";
import { productList } from "@/api/device";
import { addProduct, deleteProduct } from "@/api/order";
import { UserModule } from "@/store/modules/user";

import OrderItemSearch from "@/components/OrderItemSearch/index.vue";

@Component({
  name: "OrderBrand",
  components: {
    OrderItemSearch,
  },
})
export default class extends Vue {
  // 接受父组件的值
  @Prop({
    type: String,
    default: "0",
  })
  companyId!: any;

  @Prop({
    type: Boolean,
    default: false,
  })
  brandVisible!: Boolean;
  // 1 报修 2 添加 3 订单处理 4 任务处理 5 添加安装单 6 搜索没有数量
  @Prop({
    type: Number,
    default: 0,
  })
  enterType!: Number;
  @Prop({
    type: Object,
    default: () => ({}),
  })
  orderDetail!: any;

  private form: any = {
    amount: 1
  };
  private brandList: any = {};
  private productList: any = {};
  private moduleList: any = {};
  private isShowSearch = false;

  private brandNameAlias = "";
  private productNameAlias = "";
  private modelNameAlias = "";
  created() {
    this.getBrand("", 1);
    if (UserModule.getCompany && UserModule.getCompany.alias_set) {
      this.brandNameAlias = UserModule.getCompany.alias_set.brand_name_alias;
      this.productNameAlias =
        UserModule.getCompany.alias_set.product_name_alias;
      this.modelNameAlias = UserModule.getCompany.alias_set.model_name_alias;
    }
  }
  private getBrand(id: string, type: number) {
    let parameters: any = {};
    parameters.company_id =
      !this.companyId || parseInt(this.companyId) === 0
        ? UserModule.getCompanyId
        : this.companyId;
    parameters.product_type = type;
    switch (type) {
      case 1:
        break;
      case 2:
        parameters.brand_id = id;
        break;
      case 3:
        parameters.brand_id = this.form.brand.id;
        parameters.product_id = id;
        break;
    }

    productList(parameters)
      .then((res) => {
        switch (type) {
          case 1:
            if (res.data) {
              // 品牌默认一个时 默认选中
              this.brandList = res.data.list;
              if (this.brandList.length === 1) {
                this.form.brand = this.brandList[0];
                this.getBrand(this.form.brand.id, 2);
              }
            } else {
              this.brandList = [];
            }

            break;
          case 2:
            if (res.data) {
              this.productList = res.data.list;
            } else {
              this.productList = [];
            }

            break;
          case 3:
            if (res.data) {
              this.moduleList = res.data.list;
            } else {
              this.moduleList = [];
            }

            break;
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  private brandChange(val: any) {
    this.form.product = {};
    this.form.model = {};
    if (val && val.id) {
      this.getBrand(val.id, 2);
    } else {
      this.productList = [];
    }
  }
  private productChange(val: any) {
    this.form.model = {};
    if (val && val.id) {
      this.getBrand(val.id, 3);
    } else {
      this.moduleList = [];
    }
  }
  private moduleChange(val: any) {
    this.getBrand(this.form.product.id, 3);
  }
  // 添加品牌
  private add(productBean: any) {
    const params: any = {
      user_id: UserModule.getUserId,
      company_id:
        !this.companyId || parseInt(this.companyId) === 0
          ? UserModule.getCompanyId
          : this.companyId,
      order_id: this.orderDetail.order.id,
      brand_id: productBean.brand_id,
      brand_name: productBean.brand_name,
      product_id: productBean.product_id,
      product_name: productBean.product_name,
      model_id: productBean.model_id,
      model_name: productBean.model_name,
      user_name: UserModule.getUserName,
      amount: productBean.amount
    };
    if (this.orderDetail.order_service) {
      params.order_service_id = this.orderDetail.order_service.id;
    }
    if (this.orderDetail.order_task) {
      params.order_task_id = this.orderDetail.order_task.id;
    }
    addProduct(params)
      .then((res: any) => {
        productBean.id = res.data.id;
        // this.showSecussMsg('添加成功');
        this.$emit("confirm", productBean);
        this.$emit("close", false);
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }
  // 确认按钮判断
  private confirm() {
    if (!this.form.brand) {
      this.showErrorMsg("请选择品牌");
      return;
    }
    let productBean: any = {};

    if (this.form.brand) {
      productBean.brand_name = this.form.brand.name;
      productBean.brand_id = this.form.brand.id;
    }
    if (this.form.product) {
      productBean.product_name = this.form.product.name;
      productBean.product_id = this.form.product.id;
    }
    if (this.form.model) {
      productBean.model_name = this.form.model.name;
      productBean.model_id = this.form.model.id;
    }
    if (this.enterType === 5 || (this.enterType === 3 && parseInt(this.orderDetail.order.order_type) === 3)) {
      // 张旭东说必须填大于0的数不能不填
      if (!this.form.amount || (parseInt(this.form.amount) > 99999 || parseInt(this.form.amount) < 1)) {
        this.showErrorMsg("请输入1-99999");
        return;
      }
      productBean.amount = this.form.amount;
    }
    switch (this.enterType) {
      case 1:
      case 2:
        this.$emit("confirm", productBean);
        this.$emit("close", false);
        break;
      case 3:
        this.add(productBean);
        break;
      case 4: // 东改 任务处理 添加品牌
        this.add(productBean);
        break;
      case 5:
        this.$emit("confirm", productBean);
        this.$emit("close", false);
        break;
      case 6:
        this.$emit("confirm", productBean);
        this.$emit("close", false);
        break;
    }
  }
  private close() {
    this.$emit("close", false);
  }

  private searchItemHandle(val: any) {
    this.isShowSearch = val;
  }
  private searchConfirm(v: any) {
    this.productList = [];
    this.moduleList = [];
    if (v.brand && v.brand.id && v.product && v.product.id) {
      this.form.brand = v.brand;
      this.getBrand(v.brand.id, 2);
      this.form.product = v.product;
      this.getBrand(v.product.id, 3);
      this.form.model = v;
    } else if (v.brand && v.brand.id) {
      this.form.brand = v.brand;
      this.getBrand(v.brand.id, 2);
      this.form.product = v;
      this.getBrand(v.id, 3);
      this.form.model = {};
    } else {
      this.form.brand = v;
      this.getBrand(v.id, 2);
      this.form.product = {};
      this.form.model = {};
    }
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "success",
    });
  }
}
